module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Coffee#2-a0c3c1454f2af5605f71bb7e526a6017a60a046802c38f009cc12c9418e73ccc.svg";